import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import LabelChipList from 'components/labels/LabelChipList';
import LabelMultiSelect from 'components/labels/LabelMultiSelect';

/**
 * The merchant list's label pieces (RAT-1690), kept out of MerchantList.jsx -
 * that file sits exactly on the 1500-line lint ceiling, so anything added there
 * has to earn its place or live here.
 */

// Column factory rather than a plain object: the caller owns the columnHelper
// instance, and its `id` is what MerchantList filters on to hide the column from
// the Merchant role.
export const createMerchantLabelColumn = (columnHelper) =>
  columnHelper.accessor((row) => row?.labels, {
    id: 'labels',
    header: () => (
      <Text
        align="left"
        fontSize={{ sm: '10px', lg: '12px' }}
        color="gray.400"
        whiteSpace="nowrap"
      >
        Labels
      </Text>
    ),
    // One chip plus "+N": two chips already overflow the narrowed column once a
    // merchant carries several labels, and the clipped "+N" left no hint that
    // more existed. The "+N" carries a tooltip naming the rest.
    cell: (info) => <LabelChipList labels={info.getValue()} max={1} />,
  });

// Toolbar filter. Multi-select, matching merchants that carry ANY of the
// selected labels (OR) - the picker holds an array while the URL holds a
// comma-separated string, so the conversion lives here.
export const MerchantLabelFilter = ({ value, onChange }) => (
  <Box width={{ base: '100%', sm: 'auto' }}>
    <Text
      fontSize="xs"
      fontWeight="600"
      mb="1"
      color={value.length ? 'green.500' : 'gray.400'}
    >
      Labels
    </Text>
    <LabelMultiSelect
      value={value}
      onChange={(ids) => onChange(ids.join(','))}
      placeholder="All labels"
      buttonWidth={{ base: '100%', sm: '200px' }}
      showSelectedChips={false}
    />
  </Box>
);

MerchantLabelFilter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
